//
//
import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

import {
  DOCUMENTOS_GET_DOCUMENTACION,
  DOCUMENTOS_GET_DOCUMENTO,
  DOCUMENTOS_ADD_DOCUMENTO,
  DOCUMENTOS_UPDATE_DOCUMENTO,
  DOCUMENTOS_DEL_DOCUMENTO,
  DOCUMENTOS_UPDATE_LISTADOCUMENTOS,
  DOCUMENTOS_UPLOAD_FILE,
} from "./actionTypes"

import {
  getDocumentosDocumentacionSuccess,
  getDocumentosDocumentacionFail,
  getDocumentosDocumentoSuccess,
  getDocumentosDocumentoFail,
  postDocumentosAddDocumentoSuccess,
  postDocumentosAddDocumentoFail,
  putDocumentosUpdateDocumentoSuccess,
  putDocumentosUpdateDocumentoFail,
  delDocumentosDelDocumentoSuccess,
  delDocumentosDelDocumentoFail,
  putDocumentosUpdateListaDocumentosSuccess,
  putDocumentosUpdateListaDocumentosFail,
  postDocumentosUploadFileSuccess,
  postDocumentosUploadFileFail,
} from "./actions"

import {
  get_From_DocumentosController,
  post_To_DocumentosController,
  post_To_DocumentosController_FormData,
  put_To_DocumentosController,
  del_From_DocumentosController,
} from "../../helpers/campusvirtualbackend_helper"
//
function* fetchDocumentacion({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_DocumentosController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getDocumentosDocumentacionFail(response.Mensaje_Detalle))
    } else {
      //console.log("response.Datos:", response.Datos)
      yield put(getDocumentosDocumentacionSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getDocumentosDocumentacionFail(error))
  }
}
function* fetchDocumento({ payload: { jsonparameters } }) {
  try {
    const response = yield call(get_From_DocumentosController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(getDocumentosDocumentoFail(response.Mensaje_Detalle))
    } else {
      yield put(getDocumentosDocumentoSuccess(response.Datos))
    }
  } catch (error) {
    yield put(getDocumentosDocumentoFail(error))
  }
}
function* fetchAddDocumento({ payload: { jsonparameters } }) {
  try {
    const response = yield call(post_To_DocumentosController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(postDocumentosAddDocumentoFail(response.Mensaje_Detalle))
    } else {
      yield put(postDocumentosAddDocumentoSuccess(response.Datos))
    }
  } catch (error) {
    yield put(postDocumentosAddDocumentoFail(error))
  }
}
function* fetchUpdateDocumento({ payload: { jsonparameters } }) {
  try {
    const response = yield call(put_To_DocumentosController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(putDocumentosUpdateDocumentoFail(response.Mensaje_Detalle))
    } else {
      yield put(putDocumentosUpdateDocumentoSuccess(response.Datos))
    }
  } catch (error) {
    yield put(putDocumentosUpdateDocumentoFail(error))
  }
}
function* fetchDelDocumento({ payload: { jsonparameters } }) {
  try {
    const response = yield call(del_From_DocumentosController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(delDocumentosDelDocumentoFail(response.Mensaje_Detalle))
    } else {
      yield put(delDocumentosDelDocumentoSuccess(response.Datos))
    }
  } catch (error) {
    yield put(delDocumentosDelDocumentoFail(error))
  }
}
function* fetchUpdateListaDocumentos({ payload: { jsonparameters } }) {
  try {
    const response = yield call(put_To_DocumentosController, jsonparameters)
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(
        putDocumentosUpdateListaDocumentosFail(response.Mensaje_Detalle)
      )
    } else {
      yield put(putDocumentosUpdateListaDocumentosSuccess(response.Datos))
    }
  } catch (error) {
    yield put(putDocumentosUpdateListaDocumentosFail(error))
  }
}
function* fetchUploadFile({ payload: { jsonparameters, formData } }) {
  try {
    const response = yield call(
      post_To_DocumentosController_FormData,
      jsonparameters,
      formData
    )
    if (response.Status.toLowerCase() !== "success".toLowerCase()) {
      yield put(postDocumentosUploadFileFail(response.Mensaje_Detalle))
    } else {
      yield put(postDocumentosUploadFileSuccess(response.Datos[0]))
    }
  } catch (error) {
    yield put(postDocumentosUploadFileFail(error))
  }
}

function* DocumentosSaga() {
  yield takeEvery(DOCUMENTOS_GET_DOCUMENTACION, fetchDocumentacion)
  yield takeEvery(DOCUMENTOS_GET_DOCUMENTO, fetchDocumento)
  yield takeEvery(DOCUMENTOS_ADD_DOCUMENTO, fetchAddDocumento)
  yield takeEvery(DOCUMENTOS_UPDATE_DOCUMENTO, fetchUpdateDocumento)
  yield takeEvery(DOCUMENTOS_DEL_DOCUMENTO, fetchDelDocumento)
  yield takeEvery(DOCUMENTOS_UPDATE_LISTADOCUMENTOS, fetchUpdateListaDocumentos)
  yield takeEvery(DOCUMENTOS_UPLOAD_FILE, fetchUploadFile)
}

export default DocumentosSaga
